import { SET, RESET_STATE } from "@/stores/CommumActionTypes";
import {
	CLOSE_DRAWER,
	OPEN_DRAWER,
	TOGGLE_STRATIFICATION,
	TOGGLE_CUSTOM_DOMAIN,
	TOGGLE_CUSTOM_DOMAIN_COMPARISON,
} from "./AdvancedSettingsDrawerActionType";
import AdvancedSettingsDrawerService from "../../../service/AdvancedSettingsDrawerService";

const mutations = {
	[SET]: (state, view) =>
	{
		state.menu.currentDrawerView = view;
	},
	[TOGGLE_CUSTOM_DOMAIN]: (state, value) =>
	{
		state.menu.isCustomDomainChecked = value;
	},
	[TOGGLE_STRATIFICATION]: (state, value) =>
	{
		state.menu.isStratificationsChecked = value;
	},
	[TOGGLE_CUSTOM_DOMAIN_COMPARISON]: (state, value) =>
	{
		state.menu.isCustomDomainComparisonChecked = value;
	},
	[OPEN_DRAWER]: (state) =>
	{
		state.menu.isDrawerOpen = true;
	},
	[CLOSE_DRAWER]: (state) =>
	{
		state.menu.isDrawerOpen = false;
	},
	[RESET_STATE]: (state) =>
	{
		state.menu = AdvancedSettingsDrawerService.EmptyAdvancedSettingsDrawerMenuFactory();
	}
};

export default { mutations };
